import { restGet } from "apiCommandsExecutor/rest";

import { ConstantsDto } from "./restModels";

// ===== Константы (REST /api/rest/warehouse/v1) =====

export const getConstants = () => restGet<ConstantsDto>("/constants");
